import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import "./portal.css";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import PublicSite from "./PublicSite";
import Login from "./portal/Login";
import PortalLayout from "./portal/PortalLayout";
import Dashboard from "./portal/Dashboard";
import Masini from "./portal/Masini";
import MasinaDetaliu from "./portal/MasinaDetaliu";
import Facturi from "./portal/Facturi";
import Refacturari from "./portal/Refacturari";
import Programari from "./portal/Programari";
import Solicitari from "./portal/Solicitari";
import Imputerniciri from "./portal/Imputerniciri";
import ContClient from "./portal/ContClient";

// Protejează rutele de portal: dacă nu ești logat, te trimite la /login.
function RutaProtejata({ children }) {
  const { client, verificat } = useAuth();
  if (!verificat) {
    return <div className="portal__loading portal__loading--full">Se încarcă...</div>;
  }
  if (!client) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicSite />} />
          <Route path="/login" element={<Login />} />
          <Route
            path="/portal"
            element={
              <RutaProtejata>
                <PortalLayout />
              </RutaProtejata>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="masini" element={<Masini />} />
            <Route path="masini/:id" element={<MasinaDetaliu />} />
            <Route path="facturi" element={<Facturi />} />
            <Route path="refacturari" element={<Refacturari />} />
            <Route path="programari" element={<Programari />} />
            <Route path="solicitari" element={<Solicitari />} />
            <Route path="imputerniciri" element={<Imputerniciri />} />
            <Route path="cont" element={<ContClient />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
